// src/pages/processifyd/ProcessifydProcesses.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faFolderOpen,
  faSearch,
  faTimes,
  faChevronLeft,
  faChevronRight,
  faList
} from "@fortawesome/free-solid-svg-icons";

const ProcessifydProcesses = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [processes, setProcesses] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 8;

  const [showModal, setShowModal] = useState(false);
  const [editingProcess, setEditingProcess] = useState(null);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const [loading, setLoading] = useState(false);

  const initialForm = {
    processName: "",
    briefAboutProcess: "",
    type: "",
    subProcessUnder: "",        // This references Master Process Name
    active: "Yes",
    clientName: "21st Century Financial Services",
  };

  const [formData, setFormData] = useState(initialForm);

  // Sample Demo Data
  const demoProcesses = [
    // 🔷 MASTER PROCESSES
    {
      id: 1,
      processName: "Campaign Process",
      briefAboutProcess: "Overall process governing planning, execution and monitoring of all marketing and service campaigns.",
      type: "Master Process",
      subProcessUnder: "",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 10:00",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 10:00",
    },
    {
      id: 2,
      processName: "CRM Process",
      briefAboutProcess: "Centralized customer relationship management including complaint handling and satisfaction tracking.",
      type: "Master Process",
      subProcessUnder: "",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 10:05",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 10:05",
    },
    {
      id: 3,
      processName: "Customer Onboarding Process",
      briefAboutProcess: "End-to-end onboarding lifecycle ensuring compliance, verification, and risk checks before customer activation.",
      type: "Master Process",
      subProcessUnder: "",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 10:10",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 10:10",
    },
    {
      id: 4,
      processName: "Salary Process",
      briefAboutProcess: "Process for employee salary computation, validation, and disbursement.",
      type: "Master Process",
      subProcessUnder: "",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 10:15",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 10:15",
    },
    {
      id: 5,
      processName: "Settlement Process",
      briefAboutProcess: "Handles financial settlements including payables and receivables.",
      type: "Master Process",
      subProcessUnder: "",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 10:20",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 10:20",
    },

    // 🔶 CAMPAIGN SUB-PROCESSES
    {
      id: 6,
      processName: "Marketing Campaign Process",
      briefAboutProcess: "Planning and execution of marketing campaigns across digital and offline channels.",
      type: "Sub-Process",
      subProcessUnder: "Campaign Process",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 10:25",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 10:25",
    },
    {
      id: 7,
      processName: "Service Campaign Process",
      briefAboutProcess: "Campaigns focused on customer service improvements, engagement, and retention.",
      type: "Sub-Process",
      subProcessUnder: "Campaign Process",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 10:30",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 10:30",
    },

    // 🔶 CRM SUB-PROCESSES
    {
      id: 8,
      processName: "Complaint Management Process",
      briefAboutProcess: "Capturing, tracking, and resolving customer complaints efficiently.",
      type: "Sub-Process",
      subProcessUnder: "CRM Process",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 10:35",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 10:35",
    },
    {
      id: 9,
      processName: "CSAT Program Management Process",
      briefAboutProcess: "Measuring and improving customer satisfaction through structured feedback systems.",
      type: "Sub-Process",
      subProcessUnder: "CRM Process",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 10:40",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 10:40",
    },

    // 🔶 CUSTOMER ONBOARDING SUB-PROCESSES
    {
      id: 10,
      processName: "Account Opening",
      briefAboutProcess: "Initial step to register customer details and create account in the system.",
      type: "Sub-Process",
      subProcessUnder: "Customer Onboarding Process",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 10:45",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 10:45",
    },
    {
      id: 11,
      processName: "KYC (Know Your Customer) Verification",
      briefAboutProcess: "Verification of identity and address documents as per regulatory norms.",
      type: "Sub-Process",
      subProcessUnder: "Customer Onboarding Process",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 10:50",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 10:50",
    },
    {
      id: 12,
      processName: "Due Diligence",
      briefAboutProcess: "Risk profiling and background verification of the customer.",
      type: "Sub-Process",
      subProcessUnder: "Customer Onboarding Process",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 10:55",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 10:55",
    },
    {
      id: 13,
      processName: "Credit Checks",
      briefAboutProcess: "Assessment of customer creditworthiness using bureau and internal data.",
      type: "Sub-Process",
      subProcessUnder: "Customer Onboarding Process",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 11:00",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 11:00",
    },

    // 🔶 SETTLEMENT SUB-PROCESSES
    {
      id: 14,
      processName: "Bill Payable Process",
      briefAboutProcess: "Managing outgoing payments to vendors and service providers.",
      type: "Sub-Process",
      subProcessUnder: "Settlement Process",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 11:05",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 11:05",
    },
    {
      id: 15,
      processName: "Bill Receivable Process",
      briefAboutProcess: "Tracking and collecting incoming payments from customers.",
      type: "Sub-Process",
      subProcessUnder: "Settlement Process",
      active: "Yes",
      clientName: "21st Century Financial Services",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 11:10",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 11:10",
    },
  ];

  const loadSample = () => {
    setProcesses(demoProcesses);
  };

  const handleAddNew = () => {
    setEditingProcess(null);
    setFormData(initialForm);
    setShowModal(true);
  };

  const handleEdit = (proc) => {
    setEditingProcess(proc);
    setFormData({
      processName: proc.processName,
      briefAboutProcess: proc.briefAboutProcess || "",
      type: proc.type || "",
      subProcessUnder: proc.subProcessUnder || "",
      active: proc.active || "Yes",
      clientName: proc.clientName || "",
    });
    setShowModal(true);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete this process? This action cannot be undone.")) return;
    setProcesses((prev) => prev.filter((p) => p.id !== id));
  };

  const handleOpenProcess = (proc) => {
    // Update this route as per your actual process detail page
    navigate(`/processifyd-processhub/${proc.id}`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.processName.trim() || !formData.briefAboutProcess.trim()) {
      alert("Process Name and Brief are required.");
      return;
    }

    const newProcess = {
      id: editingProcess?.id || Date.now(),
      ...formData,
      createdBy: editingProcess?.createdBy || "Sanjeev Kumar",
      createdDate: editingProcess?.createdDate || new Date().toLocaleString("en-IN"),
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: new Date().toLocaleString("en-IN"),
    };

    if (editingProcess) {
      setProcesses((prev) =>
        prev.map((p) => (p.id === editingProcess.id ? newProcess : p))
      );
    } else {
      setProcesses((prev) => [...prev, newProcess]);
    }

    setShowModal(false);
    setFormData(initialForm);
  };

  // Filter + Pagination
  const filtered = processes.filter(
    (p) =>
      p.processName.toLowerCase().includes(search.toLowerCase()) ||
      p.subProcessUnder.toLowerCase().includes(search.toLowerCase()) ||
      p.briefAboutProcess.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / perPage);
  const paginated = filtered.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  const [showList, setShowList] = useState(false);

  const handleShowMyProcesses = async () => {
    try {
      setLoading(true);

      // 🔄 Replace this later with API call
      // const response = await axios.get("/api/processes");
      // setProcesses(response.data);

      // ✅ Temporary Demo Data (remove later)
      setProcesses([]);

      setShowList(true);
    } catch (error) {
      console.error("Error fetching processes:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 p-4 md:p-6">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-black border-b border-blue-500/40 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-cyan-300">
            ⚙️ Processifyd
          </div>
          <div className="text-xs text-gray-400">
            Process Master Management
          </div>
        </div>

        <div className="hidden md:flex items-center gap-4">
          {isLoggedIn ? (
            <>
              <span className="text-xs text-teal-300">{userName}</span>
              <button
                onClick={handleLogout}
                className="w-12 px-2 py-1 bg-red-700/80 hover:bg-red-600 rounded-md text-sm"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="w-12 px-2 py-1 border border-teal-600 hover:bg-teal-900/30 rounded-md"
            >
              🔐
            </button>
          )}
        </div>

        <button
          className="md:hidden text-2xl text-cyan-300"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-4">
          {isLoggedIn && (
            <div className="flex flex-col items-center gap-4">
              <div className="text-teal-300">{userName}</div>
              <button onClick={handleLogout} className="w-12 px-2 py-1 bg-red-700 rounded-md">⏻</button>
            </div>
          )}
        </div>
      )}

      <div className="min-h-[75vh]">
        {/* Controls */}
        <div className="mt-4 flex flex-col lg:flex-row gap-4">
          <div className="flex flex-row gap-3">
            <button
              onClick={loadSample}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-40 lg:w-48 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faPlus} />
              Load Sample Processes
            </button>
            <button
              onClick={handleShowMyProcesses}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-40 lg:w-48 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faList} />
              My Process List
            </button>
            <button
              onClick={handleAddNew}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-40 lg:w-48 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faPlus} />
              New Process
            </button>
          </div>

          <div className="relative w-full">
            <FontAwesomeIcon
              icon={faSearch}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500"
            />
            <input
              type="text"
              placeholder="Search by process name, type or master process..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
              className="w-full pl-10 pr-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:border-cyan-500/60"
            />
          </div>
        </div>

        {/* Process Cards */}
        <div className="mt-4 grid gap-4 grid-cols-1 lg:grid-cols-3 xl:grid-cols-4">
          {paginated.map((proc) => (
            <div
              key={proc.id}
              className="bg-gray-800 border border-gray-700 rounded-xl p-5 hover:border-cyan-600/50 transition-colors group"
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <h3 className="font-semibold text-base text-white group-hover:text-cyan-300 transition-colors line-clamp-2">
                    {proc.processName}
                  </h3>
                  <div className="text-sm text-gray-400 mt-1">
                    {proc.type} • Under: <span className="text-cyan-300">{proc.subProcessUnder}</span>
                  </div>
                  <div className="text-sm text-gray-400 mt-1">
                    {proc.clientName}
                  </div>
                </div>

                <div className="flex flex-col items-end gap-1">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${proc.active === "Yes" ? "bg-emerald-600" : "bg-red-600"}`}>
                    {proc.active === "Yes" ? "Active" : "Inactive"}
                  </span>
                </div>
              </div>

              <p className="mt-4 text-sm text-gray-300 line-clamp-4">
                {proc.briefAboutProcess || "No description available"}
              </p>

              <div className="mt-6 flex gap-2">
                <button
                  onClick={() => handleOpenProcess(proc)}
                  className="flex-1 py-2 bg-gradient-to-r from-cyan-700 to-teal-700 hover:from-cyan-600 hover:to-teal-600 rounded-lg font-medium flex items-center justify-center gap-2 text-sm"
                >
                  <FontAwesomeIcon icon={faFolderOpen} />
                  Open
                </button>

                <button
                  onClick={() => handleEdit(proc)}
                  className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  title="Edit Process"
                >
                  <FontAwesomeIcon icon={faEdit} className="text-yellow-400" />
                </button>

                <button
                  onClick={() => handleDelete(proc.id)}
                  className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  title="Delete Process"
                >
                  <FontAwesomeIcon icon={faTrash} className="text-red-400" />
                </button>
              </div>
            </div>
          ))}

          {paginated.length === 0 && (
            <div className="col-span-full py-12 text-center text-gray-500">
              {search ? "No processes match your search" : "No processes yet. Click 'New Process' or 'Load Sample Processes'"}
            </div>
          )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center gap-4 mt-10">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
              className="w-10 px-2 py-2 bg-gray-800 border border-gray-700 rounded-lg disabled:opacity-50"
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <span className="text-sm">
              Page <strong>{currentPage}</strong> of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
              className="w-10 px-2 py-2 bg-gray-800 border border-gray-700 rounded-lg disabled:opacity-50"
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        )}

        {showList && (
          <div className="mt-4 bg-black text-white rounded-lg p-4">
            {loading ? (
              <p className="text-yellow-200">Loading processes...</p>
            ) : processes.length === 0 ? (
              <p className="text-yellow-200">No processes found.</p>
            ) : (
              <ul className="space-y-2">
                {processes.map((proc) => (
                  <li
                    key={proc.id}
                    className="border border-gray-700 rounded p-2"
                  >
                    <p className="font-semibold text-gray-100">{proc.processName}</p>
                    <p className="text-xs text-gray-300">
                      {proc.type} {proc.subProcessUnder && `• ${proc.subProcessUnder}`}
                    </p>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}

        {/* Add / Edit Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-50">
            <div className="bg-gray-800 rounded-xl p-6 w-full max-w-2xl border border-gray-700 max-h-[92vh] overflow-y-auto">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-cyan-300">
                  {editingProcess ? "Edit Process" : "New Process"}
                </h2>
                <button
                  onClick={() => setShowModal(false)}
                  className="text-gray-400 hover:text-white w-12 text-2xl"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm mb-1.5">Process Name <span className="text-red-400">*</span></label>
                  <input
                    required
                    value={formData.processName}
                    onChange={(e) => setFormData({ ...formData, processName: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="e.g. CSAT Program Management Process"
                  />
                </div>

                <div>
                  <label className="block text-sm mb-1.5">Brief about the Process <span className="text-red-400">*</span></label>
                  <textarea
                    required
                    value={formData.briefAboutProcess}
                    onChange={(e) => setFormData({ ...formData, briefAboutProcess: e.target.value })}
                    rows={5}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="Describe the process in detail..."
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm mb-1.5">Type</label>
                    <input
                      value={formData.type}
                      onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                      className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                      placeholder="Core Process / Sub-Process / etc."
                    />
                  </div>

                  <div>
                    <label className="block text-sm mb-1.5">Under the Process (Master Process) <span className="text-red-400">*</span></label>
                    <input
                      required
                      value={formData.subProcessUnder}
                      onChange={(e) => setFormData({ ...formData, subProcessUnder: e.target.value })}
                      className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                      placeholder="e.g. Trade Finance"
                    />
                  </div>

                  <div>
                    <label className="block text-sm mb-1.5">Client <span className="text-red-400">*</span></label>
                    <input
                      required
                      value={formData.clientName}
                      onChange={(e) => setFormData({ ...formData, clientName: e.target.value })}
                      className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                      placeholder="e.g. 21st Century Financial Services"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm mb-1.5">Active <span className="text-red-400">*</span></label>
                    <select
                      value={formData.active}
                      onChange={(e) => setFormData({ ...formData, active: e.target.value })}
                      className="w-full h-12 px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg"
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-8">
                  <button
                    type="button"
                    onClick={() => setShowModal(false)}
                    className="px-6 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-8 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
                  >
                    {editingProcess ? "Update Process" : "Create Process"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <footer className="bg-black border-t border-blue-400 text-white py-4 mt-8">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <a href="/about-us" className="hover:text-teal-300">About</a>
            <a href="/privacy-policy" className="hover:text-teal-300">Privacy Policy</a>
            <a href="/terms-of-use" className="hover:text-teal-300">Terms of Use</a>
            <a href="/contact-us" className="hover:text-teal-300">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProcessifydProcesses;